import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/stores/authStore";

function FullscreenLoader() {
  return (
    <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <Loader2 className="animate-spin" />
    </div>
  );
}

export function ProtectedRoute({ children, requireSuperAdmin = false }) {
  const { ctx } = useAuth();
  if (ctx === undefined) return <FullscreenLoader />;
  if (!ctx) return <Navigate to="/login" replace />;
  if (requireSuperAdmin && !ctx.is_super_admin) return <Navigate to="/dashboard" replace />;
  if (!requireSuperAdmin && ctx.is_super_admin) return <Navigate to="/admin" replace />;
  return children;
}
